/*  UI  */
import { Box, Button, Flex } from '@auviknetworks/iceberg-ui';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { usePanelContext } from './PanelContext';

export const PanelFooter = () => {
    const { t } = useTranslation();
    const {
        schema: { id, footer }
    } = usePanelContext();

    return (
        <Flex
            data-testid="dashboardPanelFooter"
            sx={{ minHeight: 0, padding: '24px 24px 0' }}
        >
            {(footer?.actions || []).map(({ href, label, format }) => (
                <Link
                    data-trackid={`panelActionLink_${id}`}
                    to={href}
                    key={label}
                >
                    <Button
                        data-trackid={`panelActionBtn_${id}`}
                        variant={format?.variant}
                        size={format?.size}
                    >
                        <Box>{t(label)}</Box>
                    </Button>
                </Link>
            ))}
        </Flex>
    );
};
